<template>
  <AppSection id="timesheet-cols" type="sub-section-1" :title="$t($getConst.pages.import_settings.timesheet_cols_title)">
    <form class="my-3">
      <b-list-group class="text-capitalize mb-4">
        <b-list-group-item
          class="d-inline justify-content-between align-items-center font-size-lg pt-3 pb-0 bg-transparent">
          <b-row>
            <b-col cols="6">
              <b-form-group id="timesheet-id" :label="$t($getConst.pages.import_settings.timesheet_week_end_date)" label-for="timesheet_id">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="timesheet_id" size="lg" required
                              v-model.trim="$v.cols.timesheets_timesheet_id.$model"
                              :class="{ 'is-invalid': $v.cols.timesheets_timesheet_id.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.timesheets_timesheet_id"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="timesheet-week-end-date" :label="$t($getConst.pages.import_settings.timesheet_week_end_date)" label-for="timesheet_week_end_date">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="timesheet_week_end_date" size="lg" required
                              v-model.trim="$v.cols.timesheets_timesheet_week_end_date.$model"
                              :class="{ 'is-invalid': $v.cols.timesheets_timesheet_week_end_date.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.timesheets_timesheet_week_end_date"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="work-days-timesheet-work-date" :label="$t($getConst.pages.import_settings.work_days_timesheet_work_date)" label-for="work_days_timesheet_work_date">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="work_days_timesheet_work_date" size="lg" required
                              v-model.trim="$v.cols.timesheets_work_days_timesheet_work_date.$model"
                              :class="{ 'is-invalid': $v.cols.timesheets_work_days_timesheet_work_date.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.timesheets_work_days_timesheet_work_date"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="contractor-name" :label="$t($getConst.pages.import_settings.contractor_name)" label-for="contractor_name">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="contractor_name" size="lg" required
                              v-model.trim="$v.cols.timesheets_contractor_name.$model"
                              :class="{ 'is-invalid': $v.cols.timesheets_contractor_name.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.timesheets_contractor_name"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="work-days-timesheet-earning-code" :label="$t($getConst.pages.import_settings.work_days_timesheet_earning_code)" label-for="work_days_timesheet_earning_code">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="work_days_timesheet_earning_code" size="lg" required
                              v-model.trim="$v.cols.timesheets_work_days_timesheet_earning_code.$model"
                              :class="{ 'is-invalid': $v.cols.timesheets_work_days_timesheet_earning_code.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.timesheets_work_days_timesheet_earning_code"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="work-days-timesheet-day-quantity" :label="$t($getConst.pages.import_settings.work_days_timesheet_day_quantity)" label-for="work_days_timesheet_day_quantity">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="work_days_timesheet_day_quantity" size="lg" required
                              v-model.trim="$v.cols.timesheets_work_days_timesheet_day_quantity.$model"
                              :class="{ 'is-invalid': $v.cols.timesheets_work_days_timesheet_day_quantity.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.timesheets_work_days_timesheet_day_quantity"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="timesheet-status" :label="$t($getConst.pages.import_settings.timesheet_status)" label-for="timesheet_status">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="timesheet_status" size="lg" required
                              v-model.trim="$v.cols.timesheets_timesheet_status.$model"
                              :class="{ 'is-invalid': $v.cols.timesheets_timesheet_status.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.timesheets_timesheet_status"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="timesheet-submitted-date" :label="$t($getConst.pages.import_settings.timesheet_submitted_date)" label-for="timesheet_submitted_date">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="timesheet_submitted_date" size="lg" required
                              v-model.trim="$v.cols.timesheets_timesheet_submitted_date.$model"
                              :class="{ 'is-invalid': $v.cols.timesheets_timesheet_submitted_date.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.timesheets_timesheet_submitted_date"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="timesheet-approved-date" :label="$t($getConst.pages.import_settings.timesheet_approved_date)" label-for="timesheet_approved_date">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="timesheet_approved_date" size="lg" required
                              v-model.trim="$v.cols.timesheets_timesheet_approved_date.$model"
                              :class="{ 'is-invalid': $v.cols.timesheets_timesheet_approved_date.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.timesheets_timesheet_approved_date"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="vendors-name" :label="$t($getConst.pages.import_settings.vendors_name)" label-for="vendors_name">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="vendors_name" size="lg" required
                              v-model.trim="$v.cols.timesheets_vendors_name.$model"
                              :class="{ 'is-invalid': $v.cols.timesheets_vendors_name.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.timesheets_vendors_name"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="sub-contractor-name" :label="$t($getConst.pages.import_settings.sub_contractor_name)" label-for="sub_contractor_name">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="sub_contractor_name" size="lg" required
                              v-model.trim="$v.cols.timesheets_sub_contractor_name.$model"
                              :class="{ 'is-invalid': $v.cols.timesheets_sub_contractor_name.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.timesheets_sub_contractor_name"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="assignment-id" :label="$t($getConst.pages.import_settings.assignment_id)" label-for="assignment_id">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="assignment_id" size="lg" required
                              v-model.trim="$v.cols.timesheets_assignment_id.$model"
                              :class="{ 'is-invalid': $v.cols.timesheets_assignment_id.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.timesheets_assignment_id"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="vendors-gp-id" :label="$t($getConst.pages.import_settings.vendors_gp_id)" label-for="vendors_gp_id">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="vendors_gp_id" size="lg" required
                              v-model.trim="$v.cols.timesheets_vendors_gp_id.$model"
                              :class="{ 'is-invalid': $v.cols.timesheets_vendors_gp_id.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.timesheets_vendors_gp_id"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="work-days-project-id" :label="$t($getConst.pages.import_settings.work_days_project_id)" label-for="work_days_project_id">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="work_days_project_id" size="lg" required
                              v-model.trim="$v.cols.timesheets_work_days_project_id.$model"
                              :class="{ 'is-invalid': $v.cols.timesheets_work_days_project_id.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.timesheets_work_days_project_id"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="client-id" :label="$t($getConst.pages.import_settings.client)" label-for="client">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else id="client" size="lg" required
                              v-model.trim="$v.cols.timesheets_client.$model"
                              :class="{ 'is-invalid': $v.cols.timesheets_client.$error }">
                </b-form-input>
                <AppFormFeedback :errors="$v.cols.timesheets_client"/>
              </b-form-group>
            </b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group>

      <AppConfirmButtons
        :submit-text="$getConst.pages.button.save"
        :cancel-text="$getConst.pages.button.cancel_changes"
        :isLoading="save_is_loading"
        @onSubmit="submit"
        @onCancel="resetData"
      />
    </form>
  </AppSection>
</template>


<script>
  import {required} from "vuelidate/lib/validators";
  import AppFormFeedback from "../../../../../components/common/form/AppFormFeedback";
  import AppConfirmButtons from "../../../../../components/common/utils/AppConfirmButtons";
  import {getCols,updateCols} from "../../../../../api/importSettings.api";
  import AppSection from "../../../../../components/common/sections/AppSection";


  export default {
    name: "timesheetCols",
    components: {AppSection, AppFormFeedback, AppConfirmButtons},
    props: {
      scope_id: null,
    },
    data() {
      return {
        cols:null,
        is_loading: false,
        save_is_loading: false,
      }
    },

    validations: {
      cols: {
        timesheets_timesheet_id:{required},
        timesheets_timesheet_week_end_date:{required},
        timesheets_work_days_timesheet_work_date:{required},
        timesheets_contractor_name:{required},
        timesheets_work_days_timesheet_earning_code:{required},
        timesheets_work_days_timesheet_day_quantity:{required},
        timesheets_timesheet_status:{required},
        timesheets_timesheet_submitted_date:{required},
        timesheets_timesheet_approved_date:{required},
        timesheets_vendors_name:{required},
        timesheets_sub_contractor_name:{required},
        timesheets_assignment_id:{required},
        timesheets_vendors_gp_id:{required},
        timesheets_work_days_project_id:{required},
        timesheets_client:{required},
      }
    },

    methods: {
      isFormInvalid() {
        this.$v.$touch();
        return this.$v.$invalid;
      },
      submit() {
        if (this.isFormInvalid()) {
          return;
        }
        this.save_is_loading = true;
        updateCols(this.scope_id, this.cols).then(
          (response) => {
            this.cols = response.data;
            this.$snotify.success(this.$t(this.$getConst.pages.import_settings.columns_updated));
            this.save_is_loading = false;
          },
          error => {
            this.handleApiError(error);
            this.save_is_loading = false;
          }
        );

      },
      resetData() {
        this.getCols();
      },
      getCols() {
        this.is_loading = true;
        getCols(this.scope_id).then(
          response => {
            this.cols = response.data;
            this.is_loading = false;
          },
          error => {
            this.handleApiError(error);
            this.is_loading = false;
          }
        );
      },
    },
    created() {
      this.getCols();
    },
  }
</script>


<style scoped>

</style>
